import { render, staticRenderFns } from "./lesson-detail.vue?vue&type=template&id=1378cfc6"
import script from "./lesson-detail.vue?vue&type=script&lang=ts"
export * from "./lesson-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports